export const GET_FEATURE_FLAG_BEGIN = 'GET_FEATURE_FLAG_BEGIN';
export const GET_FEATURE_FLAG_SUCCESS = 'GET_FEATURE_FLAG_SUCCESS';
export const GET_FEATURE_FLAG_FAIL = 'GET_FEATURE_FLAG_FAIL';
